import type { CustomField, RichLead } from '../lead.popup/types';
import type { Contact } from '../types';

import { leadApi } from '../services/api';

interface ScopeProps {
  lead: RichLead;
  autocomplete?: boolean;
  hideCustomFields?: boolean;
  hasTimer?: boolean;
  phone?: string;
  email?: string;
  saveFn(): void;
  cancelFn(): void;
}

export class LeadFormCtrl implements ScopeProps {
  static $inject = ['$scope', '$timeout'];

  declare lead: ScopeProps['lead'];
  declare autocomplete: ScopeProps['autocomplete'];
  declare hideCustomFields: ScopeProps['hideCustomFields'];
  declare hasTimer: ScopeProps['hasTimer'];
  declare phone: ScopeProps['phone'];
  declare email: ScopeProps['email'];
  declare saveFn: ScopeProps['saveFn'];
  declare cancelFn: ScopeProps['cancelFn'];

  /**
   * Should be undefined by default because we rely on one-time binding (::) in tpl
   */
  declare customFields: CustomField[];
  submitIsDisabled = false;

  constructor(
    $scope: angular.IScope,
    private $timeout: angular.ITimeoutService,
  ) {
    leadApi.getCustomFields().then((fields) => {
      $scope.$apply(() => {
        this.customFields = fields;
      });
    });

    if (this.phone) {
      this.lead.phone = this.phone;
    }

    if (this.email) {
      this.lead.email = this.email;
    }
  }

  save() {
    if (!this.submitIsDisabled) {
      this.$timeout(this.saveFn, 0);
    }

    this.submitIsDisabled = true;
  }

  cancel() {
    this.$timeout(this.cancelFn, 0);
  }

  addContact() {
    this.lead.contacts = this.lead.contacts || [];
    this.lead.contacts.push({
      value: '',
    });
  }

  trashContact(contact: Contact) {
    const contacts = this.lead.contacts || [];
    const index = contacts.indexOf(contact);

    if (index > -1) {
      contacts.splice(index, 1);
    }
  }
}
